import { SORT_ORDER, SortingListItem } from '@/opensearch';

export const sortingOptions: SortingListItem[] = [
  {
    label: 'Price Low to High',
    value: { field: 'customMinPrice', order: SORT_ORDER._ASC },
  },
  {
    label: 'Price High to Low',
    value: { field: 'customMinPrice', order: SORT_ORDER._DESC },
  },
  {
    label: 'THC High to Low',
    value: { field: 'customTHCPercentageMinValue', order: SORT_ORDER._DESC },
  },
  {
    label: 'THC Low to High',
    value: { field: 'customTHCPercentageMinValue', order: SORT_ORDER._ASC },
  },
  {
    label: 'Brand A to Z',
    value: { field: 'brand.keyword', order: SORT_ORDER._ASC },
  },
  {
    label: 'Brand Z to A',
    value: { field: 'brand.keyword', order: SORT_ORDER._DESC },
  },
  {
    label: 'Classification A to Z',
    value: { field: 'classification', order: SORT_ORDER._ASC },
  },
  {
    label: 'Classification Z to A',
    value: { field: 'classification', order: SORT_ORDER._DESC },
  },
];

export const filterTitleMapping = {
  category: 'Categories',
  brand: 'Brands',
  subtype: 'SubTypes',
  classification: 'Types',
  generals: 'Generals',
  effects: 'Effects',
  flavors: 'Flavors',
  totalThcPercent: 'THC',
  totalCbdPercent: 'CBD',
  totalTacPercent: 'TAC',
  price: 'Prices',
  customSize: 'Sizes',
  deals: 'Specials',
  ...(process?.env?.NEXT_PUBLIC_TREEZ_FILTERS_TITLE_MAPPING
    ? JSON.parse(process?.env?.NEXT_PUBLIC_TREEZ_FILTERS_TITLE_MAPPING)
    : {}),
};

export const filterAttributeNameMapping = {
  'category.keyword': 'category',
  'brand.keyword': 'brand',
  subtype: 'subtype',
  classification: 'classification',
  generals: 'generals',
  effects: 'effects',
  flavors: 'flavors',
  customTHCPercentageMinValue: 'totalThcPercent',
  customCBDPercentageMinValue: 'totalCbdPercent',
  customTACPercentageMinValue: 'totalTacPercent',
  customMinPrice: 'price',
  customSize: 'customSize',
  onSale: 'deals',
};

let defaultFilterOrder = [
  'deals',
  'category',
  'classification',
  'brand',
  'price',
  'thc',
  'tac',
  'cbd',
  'size',
  'effect',
  'flavor',
  'subType',
  'general',
];

if (process.env.NEXT_PUBLIC_TREEZ_FILTER_SORT) {
  defaultFilterOrder = process.env.NEXT_PUBLIC_TREEZ_FILTER_SORT.split(',');
}

// adding new size filter
defaultFilterOrder = defaultFilterOrder.filter(filter => filter !== 'size');

const thcIndex = defaultFilterOrder?.indexOf('thc');

if (thcIndex !== -1) {
  defaultFilterOrder.splice(thcIndex + 1, 0, 'size');
} else {
  defaultFilterOrder.unshift('size');
}

export const filtersOrder = defaultFilterOrder;
